import * as React from 'react';
import { useGlobalState } from '../hooks';
export function getPiralComponent(name) {
    return (props) => {
        const Component = useGlobalState((s) => s.components[name]);
        return Component ? React.createElement(Component, Object.assign({}, props)) : null;
    };
}
/**
 * Gets the currently registered ErrorInfo component.
 * By default the DefaultErrorInfo component is used.
 */
export const PiralError = getPiralComponent('ErrorInfo');
/**
 * Gets the currently registered LoadingIndicator component.
 * By default only Loading is rendered.
 */
export const PiralLoadingIndicator = getPiralComponent('LoadingIndicator');
/**
 * Gets the currently registered Router component.
 * By default the BrowserRouter is used.
 */
export const PiralRouter = getPiralComponent('Router');
/**
 * Gets the currently registered Layout component.
 * By default the children are rendered.
 */
export const PiralLayout = getPiralComponent('Layout');
/**
 * Gets the currently registered Debug component.
 * By default nothing is used.
 */
export const PiralDebug = getPiralComponent('Debug');
//# sourceMappingURL=components.js.map